// extracted by mini-css-extract-plugin
export default {"container":"styles_container__AEF5R","header":"styles_header__NQfkr","main":"styles_main__Vai50","footer":"styles_footer__dHpIY"};